import { Navigate, Outlet } from 'react-router-dom';
import RootLayout from "../layout";
import { useAuth } from './AuthProvider';

const PrivateRoutes = () => {
    const { loading, isAuthenticated } = useAuth();
    if (loading) return null;
    return isAuthenticated ? <RootLayout><Outlet /></RootLayout> : <Navigate to="/login" replace />
}

export default PrivateRoutes;